import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'exclusive-to-sk',
    data(){
        return {
            tabs: [],
            routeName: this.$route.name,
            googleAds: process.env.GOOGLE_AD_ENV == 'production'
                ? {
                    left: '/40862963/SK-EventsAndExperiences-Wallpaper-Left',
                    right: '/40862963/SK-EventsAndExperiences-Wallpaper-Right',
                    top: '/40862963/SK-HomeP-320x50',
                    topLg: '/40862963/SK-HomeP-728x90'
                  }
                : {
                    left: '/40862963/SK-EventsAndExperiences-Wallpaper-Left',
                    right: '/40862963/SK-EventsAndExperiences-Wallpaper-Right',
                    top: '/40862963/SK-HomeP-320x50',
                    topLg: '/40862963/SK-HomeP-728x90'
                  },
        }
    },

    computed: {
        // returns the index of the selected tab  or changes the route to the given tab by its index.
        activeTab: {
            get: function () {
                return this.tabs ? this.tabs.findIndex((tab)=>tab.name === this.$route.name) : 0;
            },
            set: function ($tabIndex) {
                var tab = this.tabs[$tabIndex]
                if (this.$route.name !== tab.name) {
                    this.$router.push({name: tab.name});
                }
            }
        }
    },

    methods: {
        getAsyncData(){
            if (this.routeName === 'Promotions') {
              this.metaTitle = 'Promotions'
              this.metaDescription = 'Promotions at Ster-Kinekor'
            }
            if (this.routeName === 'Events') {
              this.metaTitle = 'Film Events and Screenings | Book Today'
              this.metaDescription = 'Browse our range of upcoming film events and screenings, exclusive to Ster-Kinekor. View event details and book today!'
            }
            if (this.routeName === 'Film Festivals & Live') {
              this.metaTitle = 'Upcoming Film Festivals and Live Theatre Shows | Book Today'
              this.metaDescription = 'Browse our range of exciting upcoming film festivals and theatre shows. Take a look at the various ticket prices and book today!'
            }
            this.$emit('updateHead');
        },
        pushRoute(el) {
            this.$router.push({name: el.name})
        },
        getGoogleAds() {
            googletag.cmd.push(()=> {
                googletag.display(this.adId);
                googletag.display(this.adIdMobile);
                googletag.display(this.adBGLeft);
                googletag.display(this.adBGRight);
                googletag.pubads().refresh()
            })
        },
    },

    beforeMount(){
        //dynamically determine the tabs based on the about route's children found in router/footer-nav.js
        var parentRoute = this.$route.matched.find((route)=>route.parent == undefined)
        this.tabs =  this.$router.options.routes.find((r)=>r.name === parentRoute.name).children || [];
    },

    mounted() {
        this.getGoogleAds()
    },

    watch: {
        '$route' (to) {
            this.routeName = to.name
            this.getAsyncData()
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/exclusive-to-sk/exclusive-to-sk.js